import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'site-modules/shared/components/link/link';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { isNew } from 'site-modules/shared/utils/publication-states';

export const HeaderCoreLink = ({
  children,
  dataTrackingId = undefined,
  dataTrackingValue = undefined,
  makeNiceName = undefined,
  modelNiceName = undefined,
  make = undefined,
  model = undefined,
  year = undefined,
  pubStates = {},
}) => {
  return (
    <Link
      to={getCoreUrl({ makeSlug: makeNiceName, modelSlug: modelNiceName, year }, !isNew(pubStates))}
      data-tracking-id={dataTrackingId}
      data-tracking-value={dataTrackingValue}
      aria-label={`${year} ${make} ${model}`}
    >
      {children}
    </Link>
  );
};

HeaderCoreLink.propTypes = {
  dataTrackingId: PropTypes.string,
  dataTrackingValue: PropTypes.string,
  makeNiceName: PropTypes.string,
  modelNiceName: PropTypes.string,
  make: PropTypes.string,
  model: PropTypes.string,
  year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pubStates: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
};
